import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";
import { Button } from "../ui/button";

type DeleteDialogProps = {
  name: string;
  open: boolean;
  disabled?: boolean;
  onOpenChange: (open: boolean) => void;
  onDeleteClick: () => void;
};

export const DeleteDialog: React.FC<DeleteDialogProps> = ({
  name,
  open,
  disabled,
  onOpenChange,
  onDeleteClick,
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete {name}</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogDescription>
          Are you sure you want to delete {name}? This action cannot be undone.
        </AlertDialogDescription>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={disabled}>Cancel</AlertDialogCancel>
          <Button
            variant="destructive"
            size="sm"
            onClick={() => {
              onDeleteClick();
              onOpenChange(false);
            }}
            disabled={disabled}
          >
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
